// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".webinar-button{background:var(--button-color);color:var(--button-text-color);text-decoration:none;text-transform:uppercase;white-space:nowrap;text-overflow:ellipsis;max-width:100%;font-weight:700;padding:8px 15px;border-radius:3px;margin:0 10px 10px 0}", ""]);
// Exports
module.exports = exports;
